import { Ability, AbilityBuilder } from "@casl/ability";
import { UserRoleEnumCrossModel, AccessTokenJsConstantsCrossModel } from "../../models";
export var AbilitySubjects;
(function (AbilitySubjects) {
    AbilitySubjects["LeagueMatchResults"] = "LeagueMatchResults";
})(AbilitySubjects || (AbilitySubjects = {}));
function subjectName(item) {
    if (!item || typeof item === "string") {
        return item;
    }
    return item.__type;
}
export const ability = new Ability([], { subjectName });
export const updateUserPermissions = (clubId) => {
    const bplayV2 = JSON.parse(window.localStorage.getItem(AccessTokenJsConstantsCrossModel.localStorageVariableName));
    const unionClubId = bplayV2[AccessTokenJsConstantsCrossModel.unionClubIdKey];
    const userRoles = bplayV2[AccessTokenJsConstantsCrossModel.userRolesKey];
    // union club has global (all) privileges, all others have club privileges
    const unionClubUserRole = userRoles.find((ur) => ur.ci === unionClubId);
    if (unionClubUserRole) {
        ability.update(defineRulesFor(unionClubUserRole));
    }
    else {
        const userRole = userRoles.find((ur) => ur.ci === clubId);
        if (userRole)
            ability.update(defineRulesFor(userRole));
    }
    // 
    function defineRulesFor(userRole) {
        const { can, cannot, rules } = AbilityBuilder.extract();
        if (hasRoles(userRole.rm, UserRoleEnumCrossModel.readLeagueMatchResult)) {
            can("view", AbilitySubjects.LeagueMatchResults);
        }
        if (hasRoles(userRole.rm, UserRoleEnumCrossModel.editLeagueMatchResult)) {
            can(["view", "edit"], AbilitySubjects.LeagueMatchResults);
        }
        return rules;
    }
};
const hasRoles = (roleMask, role) => {
    return (roleMask & role) !== 0;
};
const setRoleMask = (roleMask, role, value) => {
    if (value) {
        if (hasRoles(role, UserRoleEnumCrossModel.administrator))
            return (roleMask = ~0);
        else
            return (roleMask |= role);
    }
    else {
        return (roleMask &= ~role);
    }
};
//export default ability;
